import React from "react";
import {
  Button,
  Box,
  Heading,
  Stack,
  Image,
  Text,
  IconButton,

} from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation } from "swiper";
import {AiOutlineLeft,AiOutlineRight} from "react-icons/ai";

export default function SpecialPromotion() {
  const [height,setHeight] = React.useState(360);
  const sliderRef = React.useRef();
  React.useEffect(()=>{
    const func = ()=>{
      const height = document.querySelector(".affiliate-slider-img").offsetHeight/2;
      setHeight(height === 0 ? 380 : height+20);
    } 
    func();
  });
  
  return (
    <Stack alignItems="center" py={{ base: 10, md: 20 }}>
      <Heading
        fontSize={{ base: "24px", md: "31px" }}
        fontWeight={"semibold"}
        textAlign={{ base: "center" }}
        maxW={{ base: "280px", md: "full" }}
      >
        Special Promotion
      </Heading>
      <Box width="100%" py={10} pos="relative">
        <Swiper
          slidesPerView={"4"}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          loop={true}
          breakpoints={{
            "0": {
              slidesPerView: 1,
              spaceBetween: 30,
            },
            "580": {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            "1000": {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            "1350": {
              slidesPerView: 4,
              spaceBetween: 50,
            },
          }}
          className="mySwiper affiliate-slider"
          navigation={true}
          ref={sliderRef}
          modules={[Navigation]}
        >
          {[...data,...data].map((item,index) => {
            return (
              <SwiperSlide key={index}>
                <Box>
                  <Image width="100%" src={item.imageUrl}  className="affiliate-slider-img" loading="lazy" minH={"360px"} onLoad={(e)=>{setHeight(e.target.height)}} />
                  <Stack py={3}>
                    <Text
                      fontSize={{ base:"16px",md: "18px",  xl: "20px" }}
                      fontWeight={"semibold"}
                      py={1}
                    >
                      {item.title}
                    </Text>
                    <Text fontSize={{ base:"12px",md: "14px",  xl: "16px" }}>
                      {item.description}
                    </Text>
                    <Text textDecor={"underline"}>Read more</Text>
                  </Stack>
                </Box>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <IconButton pos="absolute" top={height+"px"} left="-5" rounded="full" bg="white" shadow="md" onClick={()=>{sliderRef.current.children[1].click();}} zIndex={1}>
          <AiOutlineLeft />
        </IconButton>
        <IconButton pos="absolute" top={height+"px"} right="-5" rounded="full" bg="white" shadow="md" onClick={()=>{sliderRef.current.children[2].click();}} zIndex={1}>
          <AiOutlineRight />
        </IconButton>
      </Box>
      <Button bg="brand.500" color="white" px={6}>
        Read Our Blog
      </Button>
    </Stack>
  );
}

const data = [
  {
    title: "Earn Easy Money with the Gig Ads Widget",
    description:
      "Earn Easy Money with the Gig Ads Widget Looking to earn some extra money to fuel your summer…",
    imageUrl: "/images/become-a-seller/developer.png",
  },
  {
    title: "Earn Easy Money with the Gig Ads Widget",
    description:
      "Earn Easy Money with the Gig Ads Widget Looking to earn some extra money to fuel your summer…",
    imageUrl: "/images/become-a-seller/designer.png",
  },
  {
    title: "Earn Easy Money with the Gig Ads Widget",
    description:
      "Earn Easy Money with the Gig Ads Widget Looking to earn some extra money to fuel your summer…",
    imageUrl: "/images/become-a-seller/fashion.png",
  },
  {
    title: "Earn Easy Money with the Gig Ads Widget",
    description:
      "Earn Easy Money with the Gig Ads Widget Looking to earn some extra money to fuel your summer…",
    imageUrl: "/images/become-a-seller/artist.png",
  },
];
